var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6016 8.50732C15.8782 9.37392 16.7727 10.548 16.7727 12.1135V14.9089H20.5V12.1135C20.5 10.0821 17.1734 8.88005 14.6016 8.50732Z",
    fill: "#0088C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45432 7.45455C9.51284 7.45455 11.1816 5.78579 11.1816 3.72727C11.1816 1.66876 9.51284 0 7.45432 0C5.39581 0 3.72705 1.66876 3.72705 3.72727C3.72705 5.78579 5.39581 7.45455 7.45432 7.45455Z",
    fill: "#0088C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0455 7.45455C15.1048 7.45455 16.7727 5.78659 16.7727 3.72727C16.7727 1.66795 15.1048 0 13.0455 0C12.6075 0 12.1975 0.0931816 11.8062 0.223636C12.5796 1.18341 13.0455 2.40409 13.0455 3.72727C13.0455 5.05045 12.5796 6.27114 11.8062 7.23091C12.1975 7.36136 12.6075 7.45455 13.0455 7.45455Z",
    fill: "#0088C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45455 8.38623C4.96659 8.38623 0 9.63487 0 12.1135V14.909H14.9091V12.1135C14.9091 9.63487 9.9425 8.38623 7.45455 8.38623Z",
    fill: "#0088C2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBUsers);
export default __webpack_public_path__ + "static/media/bUsers.8c657529c61ec660b824e9cde3fc77b1.svg";
export { ForwardRef as ReactComponent };